import SsrRedirectError from '@yandex-int/k-common/server/ssr-redirect-error';

/** Редиректит в новый Учебник по переданному пути */
export function RedirectToNewLab(newPath: string) {
    if (!isSSR) {
        window.location.href = newPath;
    } else {
        throw new SsrRedirectError('RedirectToNewLab', newPath);
    }

    return null;
}
